/**
 * Spacing configuration for Vuexy theme.
 * Matches Vuexy's spacing system exactly.
 */

const spacing = {
  spacing: (factor: number) => `${0.25 * factor}rem`
};

export default spacing;
